export default __webpack_public_path__ + "static/evan-d618b55fd8849cc05608048e21a70b69.png";